var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useMemo, Children } from "react";
import { StyledTabs } from "./Tabs.style";
import { TabsContext } from "./TabsContext";
import TabPanel from "./TabPanel";
const isTabPanel = (el) => React.isValidElement(el) && el.type === TabPanel;
const Tabs = (_a) => {
    var { id, responsive = false, children } = _a, rest = __rest(_a, ["id", "responsive", "children"]);
    const [selectedTab, setSelectedTab] = useState("");
    const tabPanels = useMemo(() => {
        return Children.toArray(children)
            .filter(isTabPanel)
            .map((child) => ({
            tab: child.props.tab,
            id: child.props.id,
        }));
    }, [children]);
    const contextValue = useMemo(() => ({
        responsive,
        selectedTab,
        setSelectedTab,
        tabPanels,
    }), [responsive, selectedTab, tabPanels]);
    return (React.createElement(TabsContext.Provider, { value: contextValue },
        React.createElement(StyledTabs, Object.assign({ id: id }, rest), children)));
};
export default Tabs;
//# sourceMappingURL=Tabs.js.map